import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

type Document = {
  id: number;
  file: any;
  dateFrom?: Date;
  dateUntil: null | undefined | Date;
}

export function alLeastOneDateEndMustBeNotUndefined(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const documents = control.value as Document[];
    const setOfKeys = new Set();
    documents.map((document: Record<string, any>) => Object.keys(document).forEach((element: string) => {
      setOfKeys.add(element);
    }));

    if (documents.length > 0 && setOfKeys.has('dateUntil') && documents.every(({ dateUntil }) => dateUntil === undefined)) {
      return {
        description: 'Las fechas "Hasta" no pueden ser todas indefinidas. Por favor, seleccione al menos una fecha en un campo "Hasta".',
        code: '300',
      };
    }
    return null;
  };
}
